import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Full-fledged Tech Stack for{" "}
              <span>Cloud App Development Services</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              Our full-service cloud app development company uses a broad range
              of progressive technologies that help fulfill our clients’
              requirements. We incorporate architecturally significant tools and
              structures for both the front and back ends, databases, and the
              clouds. It allows us to provide highly personalized,
              cost-effective solutions, and scalable cloud applications per your
              business objectives.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Cloud Platforms">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/aws.webp"
                    alt="AWS"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/azure.webp"
                    alt="Azure"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/google_cloud.webp"
                    alt="Google Cloud"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Configuration Management">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/ansible.webp"
                    alt="Ansible"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Ansible</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/chef.webp"
                    alt="Chef"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Chef</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/puppet.webp"
                    alt="Puppet"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Puppet</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Log Management">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/elastic_search.webp"
                    alt="Elasticsearch"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Elasticsearch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/loggly.webp"
                    alt="Loggly"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Loggly</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/splunk.webp"
                    alt="Splunk"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Splunk</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Performance">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/apache.webp"
                    alt="Apache"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/firewall.webp"
                    alt="Firewall"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Firewall</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/nginx.webp"
                    alt="Nginx"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Nginx</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Databases">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/mongoDB.webp"
                    alt="MongoDB"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/mySQL.webp"
                    alt="MySQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/postgreSQL.webp"
                    alt="PostreSQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
